export default __webpack_public_path__ + "static/media/hht1_ep5_minisitcom_01.e31e9704.png";